import { useState, useEffect } from "react";
import "./Dashboard.css";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import Avatar from "react-avatar";
import { ParentEditKid } from "./UpdateDetails/EditKidPassword";
import { useNavigate } from "react-router-dom";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import LeaveParentDashboardModal from "./LeaveParentModal";
import { useSchoolParentApi } from "../../../../utils/useSchoolParentApi";
import toast from "react-hot-toast";
import { getSubdomain } from "../../../../utils/subdomian";

export const SchlParentDashboard = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { ClearUser } = useAuth();
  const { studentLogin } = useAuthStudent();
  const navigate = useNavigate();
  const currentSubdomain = getSubdomain();

  // Local state
  const [kidsData, setkidsData] = useState([]);
  const [loadingKidData, setloadingKidData] = useState(true);
  const [error, setError] = useState("");
  const [kidToUpdate, setkidToUpdate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalParentLeave, setShowModalParentLeave] = useState(false);
  const [studentLoginId, setStudentLoginId] = useState("");
  const parent_type = "school_parent";
  const { apiCall } = useSchoolParentApi();

  const copySubdomainUrl = (subdomain) => {
    if (!subdomain) return;

    const url = `https://${subdomain}.${process.env.REACT_APP_MAIN_DOMAIN}`;

    navigator.clipboard.writeText(url).then(() => {
      toast.success("School login url copied!");
    });
  };

  // 🔹 Fetch kids
  useEffect(() => {
    const fetchUserData = async () => {
      setloadingKidData(true);
      setError("");
      try {
        const data = await apiCall(
          `${apiUrl}/parent/account-details?parent_type=${parent_type}`,
        );
        setkidsData(data);
      } catch (err) {
        setError("Unable to fetch students. Please try again.");
      } finally {
        setloadingKidData(false);
      }
    };

    fetchUserData();
  }, [apiUrl]);

  // 🔹 Password modal
  const passwordChange = (kid) => {
    setkidToUpdate(kid);
    setShowModal(true);
  };

  // 🔹 Switch student
  const switchStudent = async () => {
    try {
      const data = await apiCall(`${apiUrl}/parent/student/switch`, {
        method: "POST",
        body: { student_id: studentLoginId },
      });

      if (data?.student) {
        ClearUser();
        studentLogin(data);
        navigate("/student/start-your-quest");
      }

      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleSwitchStudent = async () => {
    try {
      await switchStudent();
    } catch (err) {
      console.error("Failed to switch student", err);
    }
  };

  return (
    <div className="dashboardBody">
      <div className="container-fluid p-0">
        <div className="p-0" id="mainContent">
          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <p className="tchrdashboard-cmntitl mb-0">Parent Dashboard</p>
                </div>

                {/* Error message */}
                {error && (
                  <div className="text-danger text-center mb-3">{error}</div>
                )}

                {/* Loading skeleton */}
                {loadingKidData ? (
                  <div className="row">
                    {Array.from({ length: 4 }).map((_, idx) => (
                      <div
                        key={idx}
                        className="col-md-6 col-sm-6 col-lg-3 mb-4"
                      >
                        <div className="card rounded-4 shadow-sm h-100 border-0">
                          <div className="card-body d-flex flex-column align-items-center text-center p-4">
                            <div
                              className="rounded-circle bg-light mb-3"
                              style={{ width: 80, height: 80 }}
                            ></div>
                            {["col-8", "col-6", "col-4", "col-7"].map(
                              (w, i) => (
                                <div
                                  className="placeholder-glow w-100 mb-1"
                                  key={i}
                                >
                                  <span
                                    className={`placeholder ${w} rounded`}
                                  ></span>
                                </div>
                              ),
                            )}
                            <div className="d-grid gap-2 w-100 mt-auto">
                              <span className="btn btn-primary btn-sm disabled placeholder col-12 rounded-pill"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row">
                    {Array.isArray(kidsData?.students) &&
                    kidsData.students.length > 0 ? (
                      (() => {
                        let firstUnsubscribedFound = false;
                        // ✅ Filter by subdomain match
                        const filteredKids = kidsData.students.filter((kid) => {
                          const schoolSubdomain = kid?.institution?.subdomain;

                          // If match → only that school
                          if (schoolSubdomain === currentSubdomain) {
                            return true;
                          }

                          return false;
                        });

                        // If no match found → show all
                        const finalKids =
                          filteredKids.length > 0
                            ? filteredKids
                            : kidsData.students;

                        const sortedKids = [...finalKids].sort((a, b) =>
                          a.is_subscribed === b.is_subscribed
                            ? 0
                            : a.is_subscribed
                              ? 1
                              : -1,
                        );

                        return sortedKids.map((kid) => {
                          const shouldShowButton = !kid?.is_subscribed;
                          const enableButton =
                            shouldShowButton && !firstUnsubscribedFound;
                          if (enableButton) firstUnsubscribedFound = true;

                          return (
                            <div
                              key={kid?.id}
                              className="col-md-6 col-sm-6 col-lg-3 mb-4"
                            >
                              <div
                                className={`card rounded-4 shadow-sm h-100 position-relative pt-2`}
                              >
                                <div
                                  className="position-absolute top-0 end-0"
                                  style={{
                                    cursor: "pointer",
                                    zIndex: 10,
                                    marginTop: "10px",
                                    marginRight: "20px",
                                  }}
                                  onClick={() =>
                                    navigate(`/school-parent/quests/${kid?.id}`)
                                  }
                                >
                                  View
                                </div>

                                <div className="card-body d-flex flex-column align-items-center text-center p-4">
                                  <div
                                    className="rounded-circle bg-light d-flex align-items-center justify-content-center mb-3"
                                    style={{ width: 80, height: 80 }}
                                  >
                                    <Avatar
                                      name={kid?.name}
                                      size="100"
                                      round
                                      color="#008EF4"
                                      fgColor="#fff"
                                      className="shadow-lg"
                                    />
                                  </div>

                                  <h5 className="card-title fw-bold mt-4">
                                    {kid?.name.charAt(0).toUpperCase() +
                                      kid?.name.slice(1)}
                                  </h5>
                                  <p className="medium mb-1">
                                    <strong>School Name:</strong>{" "}
                                    {kid?.institution?.name}
                                  </p>

                                  <p className="medium mb-1">
                                    <strong>Student Id:</strong> {kid?.username}
                                  </p>
                                  <p className="medium mb-1">
                                    <strong>Age:</strong> {kid?.age}
                                  </p>

                                  {!shouldShowButton &&
                                    Number(kid.age) < 13 && (
                                      <div className="mt-auto w-100">
                                        <button
                                          className="btn btn-outline-primary btn-md rounded-pill w-100 mt-2"
                                          style={{ backgroundColor: "#fff" }}
                                          onClick={() => {
                                            setStudentLoginId(kid.id);
                                            setShowModalParentLeave(true);
                                          }}
                                        >
                                          Go to Kid's Dashboard
                                        </button>
                                      </div>
                                    )}

                                  <div className="mt-auto w-100">
                                    <button
                                      className="btn btn-link small p-0 mt-3"
                                      onClick={() => passwordChange(kid)}
                                    >
                                      Change Password
                                    </button>
                                  </div>

                                  <p className="medium mb-1 d-flex align-items-center gap-2 mt-2">
                                    <strong>Login Url:</strong>
                                    <span>{kid?.institution?.subdomain}</span>

                                    <button
                                      className="btn btn-sm btn-outline-secondary rounded-pill"
                                      onClick={() =>
                                        copySubdomainUrl(
                                          kid?.institution?.subdomain,
                                        )
                                      }
                                    >
                                      Copy URL
                                    </button>
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        });
                      })()
                    ) : (
                      <div className="col-md-12 text-center">
                        Students Not Available.
                      </div>
                    )}
                  </div>
                )}

                {/* Password Modal */}
                {showModal && (
                  <ParentEditKid
                    showModal={showModal}
                    handleQuestClose={() => setShowModal(false)}
                    kid={kidToUpdate}
                  />
                )}
              </div>
            </section>

            {/* Background images */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                width: "auto",
                zIndex: -1,
              }}
            />
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1,
              }}
            />
          </div>
        </div>

        {/* Leave Parent Modal */}
        <LeaveParentDashboardModal
          show={showModalParentLeave}
          handleClose={() => setShowModalParentLeave(false)}
          handleContinue={handleSwitchStudent}
        />
      </div>
    </div>
  );
};
